<!-- Index-1 component -->
<script>
	import Navbar from '../../Components/Navbar.svelte';

    import HomeSection from '../Layout2/HomeSection.svelte';
	import Client from '../../Components/Client.svelte';
	import AboutUs from '../../Components/AboutUs.svelte';
	import Services from '../../Components/Services.svelte';
	// import Team from '../../Components/Team.svelte';
	import Pricing from '../../Components/Pricing.svelte';
	// import Testimonial from '../../Components/Testimonial.svelte';
	// import Blog from '../../Components/Blog.svelte';
	import Contact from '../../Components/Contact.svelte';
	import Footer from '../../Components/Footer.svelte';
	import Switcher from './../../Components/Switcher.svelte';

	import data from '../../Data/data';

</script>

<!-- STRAT NAVBAR -->
<Navbar extraclass="" />
<!-- END NAVBAR -->
<HomeSection />
<Client />
<AboutUs />
<Services serviceData={data.SERVICE_DATA} websiteData={data.WEBSITE_DESCRIPTION} />
<!-- <Team teamData={data.TEAM_DATA} /> -->
<Pricing pricingData={data.PRICING_DATA} />
<!-- <Testimonial testimonialData={data.TESATIMONIAL_DATA} startedData={data.GET_STARTED} /> -->
<!-- <Blog blogData={data.BLOG_DATA} /> -->
<Contact />
<Footer />
<Switcher />
